import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { JwtModule } from "@auth0/angular-jwt";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./shared/components/header/header.component";
import { FooterComponent } from "./shared/components/footer/footer.component";
import { SidebarComponent } from "./shared/components/sidebar/sidebar.component";
import { TypingThreeDotLoaderComponent } from "./shared/components/typing-three-dot-loader/typing-three-dot-loader.component";
import { ChatbotPanelComponent } from "./resources/chatbot-support/chatbot-panel/chatbot-panel.component";
import { PromptComponent } from "./resources/chatbot-support/prompt/prompt.component";
import { BrTagPipe } from "./shared/pipes/newline.pipe";
import { ConversationComponent } from "./resources/chatbot-support/conversation/conversation.component";
import { ErrorComponent } from "./shared/components/error/error.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "./core/services/auth.service";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TokenInterceptorProvider } from "./core/interceptors/token.interceptor";
import { LoadingInterceptorProvider } from "./core/interceptors/loading.interceptor";
import { CachingInterceptor } from "./core/interceptors/caching.interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { ToastrModule } from "ngx-toastr";
import { NotyfToast } from "./shared/components/toastr/notyf-toastr.component";
import { CdpToastr } from "./shared/components/toastr/cdp.toastr";
import { DailogComponent } from "./shared/components/dailog/dailog/dailog.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ForgotPasswordComponent } from "./shared/components/dailog/forgot-password/forgot-password.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CdkTableModule } from "@angular/cdk/table";
import { CdkTreeModule } from "@angular/cdk/tree";
import { IfRolesDirective } from "./shared/directives/if-roles.directive";
import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
} from "@angular/common";
import { CommonService } from "./core/services/common.service";
import { AppRoutingModule } from "./app-routing.module";
import { BreadcrumbComponent } from "./shared/components/breadcrumb/breadcrumb.component";
import { ActionPreviewComponent } from "./shared/components/action-preview/action-preview.component";
import { MaterialModule } from "./material.module";
import { NgxFileDropModule } from "ngx-file-drop";
import { MainLayoutComponent } from "./resources/main-layout/main-layout.component";
import { DatePickerCustomHeaderComponent } from "./shared/components/date-picker-custom-header/date-picker-custom-header.component";
import { TermsConditionsComponent } from "./resources/client/terms-conditions/terms-conditions.component";
import { AddFundsComponent } from "./resources/client/add-funds/add-funds.component";
import { ServerDownComponent } from "./server-down/server-down.component";
import { NotificationService } from "./notification.service";
import { SharedModule } from "./shared/shared.module";

@NgModule({
  declarations: [
    BrTagPipe,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    MainLayoutComponent,
    TypingThreeDotLoaderComponent,
    ChatbotPanelComponent,
    PromptComponent,
    ConversationComponent,
    AppComponent,
    ErrorComponent,
    NotyfToast,
    CdpToastr,
    DailogComponent,
    ForgotPasswordComponent,
    IfRolesDirective,
    BreadcrumbComponent,
    ActionPreviewComponent,
    DatePickerCustomHeaderComponent,
    TermsConditionsComponent,
    AddFundsComponent,
    ServerDownComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    NgxSpinnerModule,
    JwtModule,
    CommonModule,
    NgbModule,
    SharedModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    CdkTableModule,
    ScrollingModule,
    FormsModule,
    CdkTreeModule,
    MaterialModule,
    NgxFileDropModule,
    TooltipModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 10000,
      toastComponent: CdpToastr,
      positionClass: "toast-top-right",
      toastClass: "toast-top-right",
    }),
    BrowserAnimationsModule,
  ],
  providers: [
    AuthService,
    TokenInterceptorProvider,
    LoadingInterceptorProvider,
    CachingInterceptor,
    CommonService,
    NotificationService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
